const xs = 480;
const sm = 768;
const md = 992;
const lg = 1200;

const queries = [
  {key: 'XS', query: `(max-width: ${xs - 1}px)`},
  {key: 'MS', query: `(min-width: ${xs}px) and (max-width: ${sm - 1}px)`},
  {key: 'SM', query: `(min-width: ${sm}px) and (max-width: ${md - 1}px)`},
  {key: 'MD', query: `(min-width: ${md}px) and (max-width: ${lg - 1}px)`},
  {key: 'LG', query: `(min-width: ${lg}px)`}
];

var subscribers;
var mq = {};

function initMq() {
  subscribers = [];
  mq = getMq();

  queries.map((item) => {
    window.matchMedia(item.query).addListener(publish);
  });
}

function getMq() {
  var _mq = {};

  queries.map((item) => {
    _mq[item.key] = window.matchMedia(item.query).matches;
  });

  _mq['MS_AND_DOWN'] = _mq.MS || _mq.XS;
  _mq['SM_AND_DOWN'] = _mq.SM || _mq.MS_AND_DOWN;
  _mq['MD_AND_DOWN'] = _mq.MD || _mq.SM_AND_DOWN;

  _mq['MD_AND_UP'] = _mq.MD || _mq.LG;
  _mq['SM_AND_UP'] = _mq.SM || _mq.MD_AND_UP;
  _mq['MS_AND_UP'] = _mq.MS || _mq.SM_AND_UP;

  return _mq;
}

function publish(q) {
  mq = getMq();

  if (q.matches) {
    subscribers.map((cb) => {
      if (cb) cb();
    });
  }
}

export function watchMedia (cb) {
  if (subscribers === undefined) initMq();

  const index = subscribers.push(cb) - 1;
  return {
    remove: () => {
      delete subscribers[index];
    }
  };
}

export function getMedia() {
  return mq;
}
